import React, { useState, useEffect, useContext } from 'react';
import LayautContext from 'Context/ContextLayaut';
import { RestorePage } from '@mui/icons-material';
import {
    Grid,
    Typography,
    colors,
    Avatar,
    Button,
    Card,
    CardContent,
    Divider,
    CardHeader,
    CardMedia,
    CircularProgress,
    Stack,
    Tooltip
} from '@mui/material';
import Link from '@mui/material/Link';
import { makeStyles } from '@mui/styles';
import { styled, useTheme } from '@mui/material/styles';
import { useForm, Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';

import Services from 'utils/serviciosVentas';
import oro from 'assets/images/oro.png';
import plata from 'assets/images/plata.png';
import bronce from 'assets/images/bronce.png';
import rechazado from 'assets/images/rechazar.png';
import burrito from 'assets/images/burrito.png';
import { Box } from '@mui/system';
import { gridTabIndexColumnHeaderSelector } from '@mui/x-data-grid';
import PorcentajeCiruclaV2 from './PorcentajeCiruclaV2';
// import VistaExam from './VistaExam';
import VistaExam from '../../Calificaciones/components/OpcRegistro';
// ==============================|| DEFAULT DASHBOARD ||============================== //
const gifaprobado  = 'https://universidadmaderas.com/IMG/examen_completo.gif';
const gifnoaprobado = 'https://universidadmaderas.com/IMG/examen_incompleto.gif';
const Item = styled(Typography)(({ theme }) => ({
    ...theme.typography.body1,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary
}));
const useStyles = makeStyles((theme) => ({
    respuestaCorrecta: {
        background: theme.palette.success.main,
        border: 0,
        borderRadius: 3,
        color: 'white'
    },
    respuestaSeleccionada: {
        border: `3px solid ${theme.palette.info.main}`
    },
    cardHeader: {
        backgroundColor: theme.palette.warning.light
    }
}));

const style = {
    circularProgres: {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
};

const Calificacion = ({ permisos, usuario, data, verActividadRespondida, reiniciarExamen }) => {
    const classes = useStyles();
    const theme = useTheme();
    const context = useContext(LayautContext);
    const califAprobatoria = parseInt(data.califDetAct, 10);
    const calificacion = parseInt(data?.calificacion, 10);
    const aciertos = parseInt(data?.aciertos, 10);
    const desaciertos = parseInt(data?.desaciertos, 10);
    const isAprobado = parseInt(data?.isAprobado, 10);
    const tipo = parseInt(data?.tipo, 10);
    const reinicios = parseInt(data?.reinicios, 10);
    const activoReprobado = parseInt(data?.activoReprobado, 10);
    const nintentos = parseInt(data?.nintentos, 10);
    const intentosPermitidos = data.numIntentos && Number(data.numIntentos) > 0 ? Number(data.numIntentos) : 3;
    const intentosRealizados = Number.isNaN(nintentos) ? 0 : nintentos;

    const periodoFinalizado = Boolean(data?.infoGeneral?.periodoFinalizado ?? data?.periodoFinalizado);

    const intentos = reinicios + 1;

    const esEncuesta = tipo === 7 || tipo === 11;

    const mostrarFraseAristoteles = esEncuesta;

    const [showReinicio, setShowReinicio] = useState(false);

    useEffect(() => {
        if (data) {
            //  Si el periodo finalizo, no mostrar el boton de reinicio
            if (periodoFinalizado) {
                setShowReinicio(false);
                return;
            }

            if (Number(data.tipo) == 3 || Number(data.tipo) == 10) {
                if (data.numIntentos && Number(data.numIntentos) > 0) {
                    setShowReinicio(nintentos < Number(data.numIntentos));
                } else {
                    setShowReinicio(nintentos < 3);
                }
                // if (Number(data.tipoCurso) == 1) {
                //     setShowReinicio(nintentos < 3);
                // } else {
                //     const intentosTrainers = Number(data.numIntentos);
                //     setShowReinicio(intentosTrainers && intentosTrainers != null ? nintentos < intentosTrainers : nintentos < 3);
                // }
            } else {
                setShowReinicio(true);
            }
        }
    }, [data]);

    const TipoC = (props) => {
        //const image = props.isAprobado ? oro : rechazado; gifaprobado
        const image = props.isAprobado ? gifaprobado : gifnoaprobado;
        return <CardMedia image={image} sx={{ width: 500 }} component="img" />;
    };
    const PorcentajeCircular = ({ porcentaje, text, isPorcentaje, nombre, color }) => (
        <>
            <MineTooltip title={nombre}>
                <Avatar
                    variant="rounded"
                    sx={{
                        ...theme.typography.commonAvatar,
                        ...theme.typography.largeAvatar,
                        backgroundColor: theme.palette.warning.light,
                        color: theme.palette.warning.dark,
                        p: 4,
                        mb: 2
                    }}
                >
                    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                        <CircularProgress size={50} variant="determinate" color="warning" value={porcentaje} />
                        <Box sx={style.circularProgres}>
                            <Typography variant="caption" color="text.secondary">
                                {text}
                            </Typography>
                        </Box>
                    </Box>
                </Avatar>
            </MineTooltip>
        </>
    );

    const ItemPorcentaje = ({ porcentaje, text, isPorcentaje, nombre, color }) => (
        <>
            <MineTooltip title="AAA">
                <Avatar
                    variant="rounded"
                    sx={{
                        ...theme.typography.commonAvatar,
                        ...theme.typography.tallAvatar,
                        backgroundColor: theme.palette.primary.mine,
                        p: 4,
                        mb: 2
                    }}
                >
                    <Stack spacing={1} display="flex" justifyContent="space-between">
                        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                            <CircularProgress size={50} variant="determinate" color="success" value={50} />
                            <Box sx={style.circularProgres}>
                                <Typography variant="cardSubtitle">AAA</Typography>
                            </Box>
                        </Box>
                        <Typography variant="cardBody">AAA</Typography>
                    </Stack>
                </Avatar>
            </MineTooltip>
        </>
    );

    const MineTooltip = ({ title, children }) => (
        <Tooltip title={title} disableInteractive>
            {children}
        </Tooltip>
    );

    const columns = [
        { label: 'Pregunta', name: 'npregunta', filtrar: true },
        {
            label: 'Estatus',
            name: 'isnCorrecta',
            type: { opcion: 'etiqueta' },
            style: (row) => ({
                fontWeight: 'bold',
                color: 'white',
                backgroundColor: row.isCorrecta == 1 ? colors.green[500] : colors.red[500]
            }),
            filtrar: {
                id: 'isCorrecta',
                value: 'isnCorrecta',
                ctl: [
                    { isCorrecta: '1', isnCorrecta: 'Correcta' },
                    { isCorrecta: '0', isnCorrecta: 'Incorrecta' }
                ]
            }
        }
    ];

    const handleinput = () => {
        context.formulario.abrir({
            open: true,
            titulo: 'Resultado de examen',
            width: 'md',
            propsForm: { data: data, columns: columns },
            formulario: VistaExam,
            isVer: true
        });
    };

    return (
        <Card style={{ height: '60vh', overflowY: 'auto' }}>
            {tipo == 3 || tipo == 10 ? (
                <CardHeader
                    style={{ textAlign: 'center' }}
                    title={`${isAprobado ? '¡FELICIDADES!' : 'NO ACREDITADO'}`}
                    subheader={`${
                        isAprobado
                            ? 'Has terminado la lección satisfactoriamente.'
                            : showReinicio
                            ? 'Aprender es un proceso. Intenta nuevamente la evaluación y sigue avanzando en tu aprendizaje'
                            : 'Has agotado tus intentos disponibles para este examen. Contacta a tu administrador si necesitas más oportunidades.'
                    }`}
                />
            ) : (
                <CardHeader
                    style={{ textAlign: 'center' }}
                    title={`${isAprobado ? 'ENCUESTA FINALIZADA' : ''}`}
                    subheader={`${isAprobado ? 'Gracias por aportar tus comentarios.' : ''}`}
                />
            )}

            <CardContent style={{ textAlign: 'center' }}>
                {![undefined, null, ''].includes(calificacion) && (tipo == 3 || tipo == 10) ? (
                    <Grid container spacing={3} columns={12}>
                        <Grid item xs={12}>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <TipoC isAprobado={isAprobado} />
                            </div>
                            <CardHeader
                                style={{ textAlign: 'center' }}
                                title={`${isAprobado ? 'Aprobado' : 'No Aprobado'}`}
                                subheader={`Puntuación: ${calificacion}%`}
                            />
                            {/* {isAprobado ? (
                                <Link href="#" onClick={() => handleinput(nintentos)} style={{ Color: colors.green[500] }}>
                                    Ver examen
                                </Link>
                            ) : (
                                ''
                            )} */}
                        </Grid>
                        <Grid item xs={12}>
                            <Stack spacing={2} direction="row" display="flex" justifyContent="space-between">
                                {/* <ItemPorcentaje /> */}
                                <PorcentajeCircular
                                    porcentaje={100}
                                    text={`${califAprobatoria}`}
                                    isPorcentaje
                                    nombre="Calificación para aprobar."
                                    color="primary"
                                />
                                <PorcentajeCircular
                                    porcentaje={calificacion}
                                    text={`${calificacion}%`}
                                    isPorcentaje
                                    nombre="Calificación del examen."
                                    color="primary"
                                />
                                <PorcentajeCircular
                                    porcentaje={(aciertos / (aciertos + desaciertos)) * 100}
                                    text={aciertos.toFixed(0)}
                                    nombre="Aciertos"
                                    color="success"
                                />
                                <PorcentajeCircular
                                    porcentaje={(desaciertos / (aciertos + desaciertos)) * 100}
                                    text={desaciertos.toFixed(0)}
                                    nombre="Desaciertos"
                                    color="error"
                                />
                            </Stack>
                        </Grid>
                    </Grid>
                ) : null}
                <Divider />
                <Grid container spacing={1} sx={{ mt: 2 }} alignItems="center">
                    {/* Frase (solo encuestas) a la izquierda */}
                    <Grid item xs={12} md={5}>
                        {mostrarFraseAristoteles && (
                            <Typography variant="body2" color="text.secondary" sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                                Los grandes conocimientos engendran las grandes dudas. &quot; -Aristóteles
                            </Typography>
                        )}
                    </Grid>

                    {/* Controles a la derecha: ver detalle + intentos + reinicio */}
                    <Grid item xs={12} md={7}>
                        <Stack
                            direction="row"
                            spacing={1}
                            alignItems="center"
                            justifyContent={{ xs: 'center', md: 'flex-end' }}
                            flexWrap="wrap"
                            useFlexGap
                        >
                            {(tipo === 3 || tipo === 10) && (
                                <>
                                    <Button
                                        variant="contained"
                                        size="small"
                                        sx={{
                                            backgroundColor: theme.palette.warning.light,
                                            color: theme.palette.warning.dark,
                                            borderRadius: '8px',
                                            textTransform: 'none',
                                            boxShadow: 'none',
                                            whiteSpace: 'nowrap',
                                            flexShrink: 0,
                                            border: `1px solid ${theme.palette.warning.dark}`,
                                            '&:hover': {
                                                backgroundColor: theme.palette.warning.main,
                                                boxShadow: 'none'
                                            }
                                        }}
                                        onClick={handleinput}
                                    >
                                        Ver detalle
                                    </Button>

                                    <MineTooltip title="Intentos realizados / intentos permitidos">
                                        <Avatar
                                            variant="rounded"
                                            sx={{
                                                ...theme.typography.commonAvatar,
                                                backgroundColor: theme.palette.warning.light,
                                                color: theme.palette.warning.dark,
                                                width: 'auto',
                                                minWidth: '3.5rem',
                                                height: '2.25rem',
                                                px: 1,
                                                fontSize: '0.875rem',
                                                fontWeight: 600,
                                                flexShrink: 0
                                            }}
                                        >
                                            {`${intentosRealizados}/${intentosPermitidos}`}
                                        </Avatar>
                                    </MineTooltip>
                                </>
                            )}

                            {permisos?.reExa && showReinicio && (
                                <MineTooltip title={tipo == 3 || tipo == 10 ? 'Repetir examen' : 'Contestar nuevamente'}>
                                    <Avatar
                                        variant="rounded"
                                        sx={{
                                            ...theme.typography.commonAvatar,
                                            backgroundColor: theme.palette.warning.light,
                                            color: theme.palette.warning.dark,
                                            width: '2.25rem',
                                            height: '2.25rem',
                                            cursor: 'pointer',
                                            flexShrink: 0
                                        }}
                                        onClick={() => reiniciarExamen(data)}
                                    >
                                        <RestorePage />
                                    </Avatar>
                                </MineTooltip>
                            )}
                        </Stack>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default Calificacion;
